import { render, staticRenderFns } from "./MobileFighterThumbnails.vue?vue&type=template&id=b5be9dda&scoped=true"
import script from "./MobileFighterThumbnails.vue?vue&type=script&lang=js"
export * from "./MobileFighterThumbnails.vue?vue&type=script&lang=js"
import style0 from "./MobileFighterThumbnails.vue?vue&type=style&index=0&id=b5be9dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5be9dda",
  null
  
)

export default component.exports